import Layout from './Layout';

const Bar = ({ className = '' }) => (
  <div className={`animate-pulse rounded-sm bg-slate-800 ${className}`} />
);

/** Placeholder blocks shown while dashboard and reports data load. */
const PageSkeleton = ({ title = 'Loading' }) => (
  <Layout>
    <div className="space-y-6" aria-busy="true" aria-live="polite" data-testid="page-skeleton">
      <div>
        <p className="sr-only">{title}</p>
        <Bar className="h-10 w-64" />
        <Bar className="h-4 w-48 mt-3" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[0, 1, 2, 3].map((key) => (
          <div key={key} className="card-industrial">
            <Bar className="h-3 w-24" />
            <Bar className="h-8 w-16 mt-3" />
          </div>
        ))}
      </div>
      <div className="card-industrial space-y-3">
        <Bar className="h-4 w-40" />
        <Bar className="h-12 w-full" />
        <Bar className="h-12 w-full" />
        <Bar className="h-12 w-full" />
      </div>
    </div>
  </Layout>
);

export default PageSkeleton;
